import { ref, readonly, markRaw } from 'vue'

const modals = ref([])
let idCounter = 1

export function useModalManager() {
  const open = (options) => {
    const id = idCounter++

    modals.value.push({
      id,
      component: markRaw(options.component),  
      props: options.props || {},
    })

    return id
  }

  const close = (id, result) => {
    const index = modals.value.findIndex((m) => m.id === id)
    if (index !== -1) {
      const [modal] = modals.value.splice(index, 1)
      modal.resolve?.(result)
    }
  }

  const openAsPromise = (options) => {
    return new Promise((resolve) => {
      const id = idCounter++

      modals.value.push({
        id,
        component: markRaw(options.component), 
        props: options.props || {},
        resolve,
      })
    })
  }

  return {
    modals: readonly(modals),
    open,
    close,
    openAsPromise,
  }
}
